class DarkStagReveal {
  constructor(root = document) {
    this.items = root.querySelectorAll('.ds-reveal:not(.is-visible)');
    if (!this.items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    this.items.forEach((item, index) => {
      item.style.setProperty('--ds-reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.1 });

    this.items.forEach((item) => this.observer.observe(item));
  }
}

class DarkStagChrome {
  constructor() {
    this.scroller = document.querySelector('.page-wrapper');
    this.header = document.querySelector('.ds-header-section');
    this.progress = document.querySelector('.ds-scroll-progress') || document.createElement('span');
    this.progress.className = 'ds-scroll-progress';
    this.progress.setAttribute('aria-hidden', 'true');
    if (!this.progress.isConnected) document.body.appendChild(this.progress);

    this.ticking = false;
    this.update = this.update.bind(this);
    this.requestUpdate = this.requestUpdate.bind(this);
    (this.scroller || window).addEventListener('scroll', this.requestUpdate, { passive: true });
    window.addEventListener('resize', this.requestUpdate, { passive: true });
    this.update();
  }

  requestUpdate() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(this.update);
  }

  update() {
    const top = this.scroller ? this.scroller.scrollTop : window.scrollY;
    const height = this.scroller
      ? this.scroller.scrollHeight - this.scroller.clientHeight
      : document.documentElement.scrollHeight - window.innerHeight;
    const progress = height > 0 ? Math.min(Math.max(top / height, 0), 1) : 0;
    this.progress.style.setProperty('--ds-scroll', progress.toFixed(4));
    this.header?.classList.toggle('is-scrolled', top > 12);
    this.ticking = false;
  }
}

document.documentElement.classList.add('ds-motion');

const initialiseDarkStag = (root = document) => {
  new DarkStagReveal(root);
  if (!window.darkStagChrome) window.darkStagChrome = new DarkStagChrome();
};

document.addEventListener('DOMContentLoaded', () => initialiseDarkStag());
document.addEventListener('shopify:section:load', (event) => initialiseDarkStag(event.target));
